import {Col, Row} from 'reactstrap';
import {useSelector} from "react-redux";

import {contactMethodsTypes} from "@utils/types/contactMethodsTypes";

import QuickPages from './QuickPages';
import SocialMedia from './SocialMedia';
import ContactUs from "./ContactUs";
import AboutUs from "./AboutUs";

import zarinPal from "@assets/images/elements/zarin.webp"
import saderat from "@assets/images/elements/saderat-logo.webp"

import "./style.scss";
import {FormattedMessage} from "react-intl";

const LinkSections = () => {
    const contactMethods = useSelector(state => state.UI);

    const phonesAndMails = contactMethods.general?.social_media?.filter(contactMethod => [contactMethodsTypes.phone, contactMethodsTypes.mobile, contactMethodsTypes.email].includes(parseInt(contactMethod.type)));

    const socialMedia = contactMethods.general?.social_media?.filter(contactMethod => !phonesAndMails.includes(contactMethod));

    const quickPages = contactMethods.general?.menu?.filter(item => item.parentId === 'main')
    return (
        <>
            <Row className="link-sections">
                <Col xs={12} sm={6} lg={3} className="link-sections-section ">
                    <AboutUs/>
                    <SocialMedia data={socialMedia}/>
                </Col>
                <Col xs={12} sm={6} lg={2} className="link-sections-section my-1 my-md-0  pl-1 pl-md-5  ">
                    <QuickPages data={quickPages} title={ <FormattedMessage id="quickPages"/>} type={1}/>
                </Col>
                <Col xs={12} sm={6} lg={2} className="link-sections-section">
                    <QuickPages data={contactMethods.home?.product_categories?.slice(0 , 5)} title={ <FormattedMessage id="Products"/>} type={0}/>
                </Col>
                <Col xs={12} sm={6} lg={3} className="link-sections-section">
                    <ContactUs data={phonesAndMails}/>
                </Col>
                <Col xs={12} sm={12} lg={2} className="link-sections-section ">
                    <div className="link-sections-section-title">
                        <h4 className="link-sections-section-title-text">
                            <FormattedMessage id="buyWithConfidence"/>
                        </h4>
                    </div>
                    <Row className="link-sections-section-nemad">
                        <Col xs={6}>
                            <div className="link-sections-section-nemad-box">
                                <a
                                    referrerPolicy='origin'
                                    target='_blank'
                                    href='https://trustseal.enamad.ir/?id=514751&Code=Xi8FWXdRq6sVMm2rMgu3zkrtBbPckPvZ'
                                >
                                    <img
                                        referrerPolicy='origin'
                                        src='https://trustseal.enamad.ir/logo.aspx?id=514751&Code=Xi8FWXdRq6sVMm2rMgu3zkrtBbPckPvZ'
                                        alt=""
                                        style={{cursor: "pointer"}}
                                        Code='Xi8FWXdRq6sVMm2rMgu3zkrtBbPckPvZ'
                                    />
                                </a>
                            </div>
                        </Col>
                        <Col xs={6}>
                            <div className="link-sections-section-nemad-box ">
                                <img
                                    src={saderat}
                                />
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default LinkSections;
